


















import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import { select } from 'components/LocaleSelect.vue'
import locales from 'src/i18n'
import { setLocale } from 'src/boot/i18n'
import MeUpdate from 'src/graphql/person/MeUpdate.gql'
import api from 'src/assets/api/gql'

@Component
export default class AccountLocaleChange extends Vue {
  person = store.state.person
  loading: boolean = false
  error: boolean = false

  get localeName (): string {
    return locales[this.$i18n.locale].messages.langname
  }

  async localeChange () {
    const locale = await select(this)
    await this.localeSave(locale)
    setLocale(locale)
  }

  async localeSave (locale: string) {
    this.loading = true
    const { data: { updatePerson } } = await api.mutate({
      query: MeUpdate,
      variables: { id: this.person.id, data: { locale } }
    })
    this.loading = false
    if (updatePerson && updatePerson.person) {
      store.setPerson(updatePerson.person)
    }
  }
}
